export const APPLICATION_ROLES = [
  'designer',
  'deployer',
  'monitor',
  'notification',
  'user',
] as const;
export const ORGANIZATION_ROLES = ['owner', 'billing', 'manager'] as const;
export const LUMEO_INTERNAL_ROLES = ['admin'] as const;

export type ApplicationRole = (typeof APPLICATION_ROLES)[number];
export type OrganizationRole = (typeof ORGANIZATION_ROLES)[number];
export type LumeoInternalRole = (typeof LUMEO_INTERNAL_ROLES)[number];

export type Role = ApplicationRole | OrganizationRole | LumeoInternalRole;

export type AccountRole = {
  name: Role;
  organization_id?: string;
  application_id?: string;
};

// Type guard
export function isApplicationRole(role: string): role is ApplicationRole {
  return ([...APPLICATION_ROLES] as string[]).includes(role);
}

// Type guard
export function isOrganizationRole(role: string): role is OrganizationRole {
  return ([...ORGANIZATION_ROLES] as string[]).includes(role);
}

// Type guard
export function isLumeoInternalRole(role: string): role is LumeoInternalRole {
  return ([...LUMEO_INTERNAL_ROLES] as string[]).includes(role);
}
